import _filter from 'lodash/filter';
const queryString = require('query-string');

/**
* Check if upgrades query parameter exist
*
*/
export const upgradeQueryExist = () => {
  const qs = queryString.parse(window.location.search).bundle;
  return (qs !== undefined) ? true : false;
}

/**
* Check if upgrades exist
*
* @param {array} upgrades - Upgrades array
*/
export const upgradeExist = (upgrades) => {
    const qs = queryString.parse(window.location.search).bundle;
    const upgradesArr = _filter(upgrades, ["tour_id", qs]);
    const upgradesExist = (qs !== undefined && upgradesArr.length > 0) ? true : false;
    return upgradesExist;
}


/**
* Upgrades name
*
* @param {array} upgrades - Upgrades array
*/
export const upgradesName = (upgrades) => {
    const qs = queryString.parse(window.location.search).bundle;
    const upgradesArr = _filter(upgrades, ["tour_id", qs]);
    const upgradeName = (upgradeExist(upgrades) && upgradesArr.length > 0) ? upgradesArr[0].name : ""; 
    return upgradeName;
}


/**
* Upgrades price
*
* @param {array} upgrades - Upgrades array
*/
export const upgradesPrice = (upgrades) => {
    const qs = queryString.parse(window.location.search).bundle;
    const upgradesArr = _filter(upgrades, ["tour_id", qs]);
    const _upgradesPrice = (upgradeExist(upgrades) && upgradesArr.length > 0) ? upgradesArr[0].price_integer : 0; 
    return _upgradesPrice;
}


/**
* Upgrades payload
*
* @param {array} upgrades - Upgrades array
*/
export const upgradePayload = (upgrades) => {
  
    if(upgradeExist(upgrades)){

      const qs = queryString.parse(window.location.search).bundle;  
      const upgradesArr = _filter(upgrades, ["tour_id", qs]);
      if(upgradesArr.length > 0){
        return upgradesArr[0];
      }
    }
}


// WEBPACK FOOTER //
// ./src/helpers/upgradesHelper.js